import _ from 'lodash';
import moment from 'moment';
import * as momentferiefr from 'moment-ferie-fr';

import { Meteor } from 'meteor/meteor';

import { Montgolfieres } from '../collections/montgolfieres/montgolfieres';
import { Reservations } from '../collections/reservations/reservations';
import { Flights } from '../collections/flights/flights';
import { Memos } from '../collections/memos/memos';

export const getAvailabilityCount = getAvailabilityCountFunc;
export const getAllAvailabilities = getAllAvailabilitiesFunc;
export const getAvailabilityTotalCount = getAvailabilityTotalCountFunc;
export const getReservedCount = getReservedCountFunc;
export const getMemoFromDate = getMemoFromDateFunc;

function getAvailabilityCountFunc(date, place, period, online = false) {
	let availability = 0;

	//date = moment(date).format('YYYY-MM-DD');
	//date = date.subtract(1, 'days');

	// Query available pilots & montgolfieres
	let projection = {
		$elemMatch: {
			startDate: {$lte: moment(date).startOf('day').toDate()},
			endDate: {$gte: moment(date).endOf('day').toDate()},
			isAvailable: true,
			place
		}
	};

	if (period) projection["$elemMatch"].period = period;
	let pilots = Meteor.users.find({"profile.availabilities": projection}).fetch();
	let montgolfieres = Montgolfieres.find({"availabilities": projection, allowedPilots: { $in: _.map(pilots, '_id') }}).fetch();

	// If not enough pilots, keep the largest montgolfieres
	while (pilots.length < montgolfieres.length) {
		let toRemove = _.minBy(montgolfieres, (montgolfiere) => {
			return montgolfiere.maxPassengers;
		});
		montgolfieres = _.reject(montgolfieres, (montgolfiere) => {
			return montgolfiere._id == toRemove._id;
		});
	}

	let nbmgf = 0;

	// Compute total availibity count
	availability += _.reduce(montgolfieres, (acc, montgolfiere) => {
		if(online) {
			const onlineAvailabilities = montgolfiere.availabilities.filter((availability) => {
				return moment(availability.startDate).isSameOrBefore(moment(date)) && moment(availability.endDate).isSameOrAfter(moment(date));
			});

			const onlineAvailability = onlineAvailabilities.length > 0
				? onlineAvailabilities[0].online
				: 0;

			if(!onlineAvailability) {
				return acc += 0;
			}

			nbmgf++;

			return acc += Math.round(montgolfiere.maxPassengers * (onlineAvailability / 100));
		}
		return acc += montgolfiere.maxPassengers;
	}, 0);

	// Subtract scheduled passengers
	let reservations = Reservations.find({'scheduledAt': {$gte: moment(date).startOf("day").toDate(), $lte: moment(date).endOf("day").toDate()}, place, $or: [{'periodTime': period},{'period': period}]}).fetch();

	let results = _.reject(reservations, (reservation) => {
		if(reservation.period && reservation.periodTime) {
			if(reservation.periodTime != period) {
				return true;
			}
		}
	});

	let total = 0;
	availability -= _.reduce(results, (acc, reservation) => {
		total += reservation.getPassengers().length;
		return acc += reservation.getPassengers().length;
	}, 0);

	return availability;
}

function getAvailabilityTotalCountFunc(date, place, period) {

	let availability = 0;

	// Query available pilots & montgolfieres
	let projection = {
		$elemMatch: {
			startDate: {$lte: date},
			endDate: {$gte: date},
			isAvailable: true,
			place
		}
	};

	if (period) projection["$elemMatch"].period = period;

	let pilots = Meteor.users.find({"profile.availabilities": projection}).fetch();
	let montgolfieres = Montgolfieres.find({"availabilities": projection, allowedPilots: { $in: _.map(pilots, '_id') }}).fetch();

	// If not enough pilots, keep the largest montgolfieres
	while (pilots.length < montgolfieres.length) {
		let toRemove = _.minBy(montgolfieres, (montgolfiere) => {
			return montgolfiere.maxPassengers;
		});
		montgolfieres = _.reject(montgolfieres, (montgolfiere) => {
			return montgolfiere._id == toRemove._id;
		});
	}

	// Compute total availibity count
	availability += _.reduce(montgolfieres, (acc, montgolfiere) => {
		return acc += montgolfiere.maxPassengers;
	}, 0);

	return availability;
}

function getReservedCountFunc(date, place, period) {

	let reserved = 0;
	let query = {
		'scheduledAt': {$gte: moment(date).startOf("day").toDate(), $lte: moment(date).endOf("day").toDate()},
		place,
		$or: [{'periodTime': period},{'period': period}]
	};

	let reservations = Reservations.find(query).fetch();

	let exclude = [];
	_.each(reservations, (reservation) => {
		if(reservation.period && reservation.periodTime) {
			if(reservation.periodTime != period) {
				reserved -= reservation.passengers.length;
			}
		}
	});

	reserved += _.reduce(reservations, (acc, reservation) => {
		return acc += reservation.passengers.length;
	}, 0);

	return reserved;
}

function getAllAvailabilitiesFunc(startDate, endDate, reservation) {
	let availabilities = [];

	startDate = moment(startDate);

	for(let i = 0; i <= moment(endDate).diff(moment(startDate), 'days'); i++) {
		let date = moment(startDate).add(i, 'days');

		console.log(date);

		if(reservation.getPeriod() == 'Libre date' || (reservation.getPeriod() == 'Semaine uniquement' && moment(startDate).add(i, 'days').isWorkingDay())) {
			if(moment().add(2, 'days').isSameOrAfter(moment(date))) {
				availabilities.push({
					'anjou': {
						'morning': 0,
						'evening': 0,
					},
					'nantes': {
						'morning': 0,
						'evening': 0
					},
					'date': date.add(1, 'days')
				});
			} else {
				availabilities.push({
					'anjou': {
						'morning': getAvailabilityCountFunc(date, "anjou", "morning", true),
						'evening': getAvailabilityCountFunc(date, 'anjou', 'evening', true),
					},
					'nantes': {
						'morning': getAvailabilityCountFunc(date, 'nantes', 'morning', true),
						'evening': getAvailabilityCountFunc(date, 'nantes', 'evening', true)
					},
					'date': date.add(1, 'days')
				});
			}
		} else {
			availabilities.push({
				'anjou': {
					'morning': 0,
					'evening': 0,
				},
				'nantes': {
					'morning': 0,
					'evening': 0
				},
				'date': date.add(1, 'days')
			});
		}

	}

	return availabilities;
}

function getMemoFromDateFunc(date) {
	let memo = Memos.find({date: date}).fetch();

	if(memo.length == 0) {
		let id = Memos.insert({date: date});
		return Memos.findOne(id);
	}

	return memo[0];
}



/** WEBPACK FOOTER **
 ** ./src/universal/helpers/availabilities.js
 **/